export const PATH = '/servicecontext';
